import Fonts from './fonts';
const resourse = {fonts: Fonts};
export default resourse;
